import {
  CREATE_STORE_REQUEST,
  CREATE_STORE_SUCCESS,
  CREATE_STORE_FAIL,
  CREATE_STORE_RESET,
  ALL_STORE_REQUEST,
  ALL_STORE_SUCCESS,
  ALL_STORE_FAIL,
  STORE_LOGIN_REQUEST,
  STORE_LOGIN_SUCCESS,
  STORE_LOGIN_FAIL,
  STORE_COMPLAINTS_REQUEST,
  STORE_COMPLAINTS_SUCCESS, 
  STORE_COMPLAINTS_FAIL,
  UPDATE_COMPLAINT_STATUS_REQUEST,
  UPDATE_COMPLAINT_STATUS_SUCCESS,
  UPDATE_COMPLAINT_STATUS_FAIL,
} from "../constants/storeConstants";

import { CLEAR_ERROR } from "../constants/userConstant";

/* CREATE STORE */
export const createStoreReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_STORE_REQUEST:
      return { loading: true };

    case CREATE_STORE_SUCCESS:
      return { loading: false, success: true, store: action.payload };

    case CREATE_STORE_FAIL:
      return { loading: false, error: action.payload };

    case CREATE_STORE_RESET:
      return {};

    default:
      return state;
  }
};

/* STORE LIST */
export const storeListReducer = (state = { stores: [] }, action) => {
  switch (action.type) {
    case ALL_STORE_REQUEST:
      return { loading: true, stores: [] };

    case ALL_STORE_SUCCESS:
      return { loading: false, stores: action.payload };

    case ALL_STORE_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

/* STORE COMPLAINTS */
export const storeComplaintReducer = (state = { complaints: [] }, action) => {
  switch (action.type) {
    case STORE_COMPLAINTS_REQUEST:
      return { loading: true, complaints: [] };

    case STORE_COMPLAINTS_SUCCESS:
      return { loading: false, complaints: action.payload };

    case STORE_COMPLAINTS_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

/* UPDATE STATUS */
export const updateComplaintStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_COMPLAINT_STATUS_REQUEST:
      return { loading: true };

    case UPDATE_COMPLAINT_STATUS_SUCCESS:
      return { loading: false, success: true };

    case UPDATE_COMPLAINT_STATUS_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

/* STORE AUTH */

// ✅ SAFE LOCAL STORAGE PARSE (crash protection)
let storedStore = null;
try {
  const raw = localStorage.getItem("storeAuth");
  storedStore = raw ? JSON.parse(raw) : null;
} catch (err) {
  console.error("Invalid storeAuth in localStorage", err);
  localStorage.removeItem("storeAuth");
  storedStore = null;
}

// ✅ FIXED INITIAL STATE
const initialState = {
  store: storedStore,
  isAuthenticated: !!storedStore,
  loading: false,
  error: null,
};

export const storeAuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case STORE_LOGIN_SUCCESS:
      // ✅ Keep localStorage synced (already correct)
      localStorage.setItem("storeAuth", JSON.stringify(action.payload));

      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        store: action.payload,
        error: null,
      };

    case STORE_LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        store: null,
        error: action.payload,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
